// methodType: GET, POST, PUT, DELETE
export const callZohoAPI = async (
  zohoApiPath: string,
  methodType?: string,
  postParams?: object,
): Promise<any> => {
  
  const urlPrefix =
    zohoApiPath.indexOf('http') === 0 ? '' : 'https://www.zohoapis.com/'
  
  const options: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'API-KEY': 'ud7^3jf(80'
    },
    body: JSON.stringify({
      url: urlPrefix + zohoApiPath,
      method: methodType ? methodType.toUpperCase() : 'GET',
      data: postParams
    })
  }
  const zohoResponse = await fetch('https://www.websiteforge.com/custom/chosen_zoho_api.php', options)
  if (!zohoResponse.ok) {
    throw new Error(`API Error: ${zohoResponse.status}`)
  }
  const response = await zohoResponse.json()
  if (response.error) {
    throw new Error(`Error: ${response.message}`)
  }
  //console.log(response);
  return response;
}
